import {EventBroker} from "../../../lib/utils/event-broker";

export const EVENTS = {
  INIT: 'INIT',
  DRAW: 'DRAW',
};

export const importHyperlinksEventBroker = new EventBroker();